module.exports = __webpack_public_path__ + "static/takeshi-eada27be852ebc5a119cc5295903a56e.png";